import React, { useEffect, useState } from 'react';
import { List, TextField, ReferenceInput, SelectInput, BooleanInput, Filter, useListContext } from 'react-admin';
import { useLocation } from 'react-router-dom';
import NoPagination from '../../lib/NoPagination';
import dataProvider from '../../lib/dataProvider';
import DatagridConfigurable from '../../lib/DatagridConfigurable.tsx';

const ListFilter = (props) => {
  const location = useLocation();
  const qs = new URLSearchParams(location.search);
  let f = {};
  try {
    f = JSON.parse(qs.get('filter') || '{}');
  }
  catch (e) {
    f = {};
  }
  const datum = f.datum || '';
  const portal = parseInt(f.portal || 0, 10);
  const roomCategory = parseInt(f.room_category || 0, 10);

  return (
    <Filter {...props}>
      <ReferenceInput source="portal" reference="ifPortalhistory/portal" alwaysOn perPage={1000} sort={{ field: 'bezeichnung', order: 'ASC' }}>
        <SelectInput optionText="bezeichnung" emptyText="-" />
      </ReferenceInput>
      <ReferenceInput key={'dt-'+portal+'-'+roomCategory} source="date" reference="ifPortalhistory/date" filter={{ portal: portal }} alwaysOn perPage={1000} sort={{ field: 'datum', order: 'ASC' }}>
        <SelectInput optionText="datum" emptyText="-" />
      </ReferenceInput>
      <ReferenceInput key={'rc-'+portal+'-'+datum} source="room_category" reference="ifPortalhistory/room_category" filter={{ portal: portal, date: datum }} alwaysOn perPage={1000} sort={{ field: 'bezeichnung', order: 'ASC' }}>
        <SelectInput optionText="bezeichnung" emptyText="-" />
      </ReferenceInput>
      <BooleanInput source="show_all_status" label="Cache Hit" alwaysOn />
    </Filter>
  );
};

const HistoryGrid = () => {
  const { filterValues } = useListContext();
  const [portalMap, setPortalMap] = useState({});
  const portalId = parseInt(filterValues.portal || 0, 10);

  useEffect(() => {
    dataProvider.getList('ifPortalhistory/portal', { pagination: { page: 1, perPage: 1000 }, sort: { field: 'bezeichnung', order: 'ASC' }, filter: {} })
      .then((res) => {
        const map = {};
        (res.data || []).forEach((r) => { map[r.id] = r; });
        setPortalMap(map);
      });
  }, []);

  if (portalId > 0 && !portalMap[portalId]) {
    return null;
  }

  const p = portalMap[portalId] || {};
  const omit = [];
  if (!p.cache_preis) omit.push('preis');
  if (!p.cache_zusatzpreise) omit.push('zusatzpreis');
  if (!p.minNacht) omit.push('minlos');
  if (!p.maxNacht) omit.push('maxlos');
  if (!(p.closedForArrival || p.closedForDeparture)) omit.push('restrictions');
  if (!p.cache_statusUpdate) omit.push('statusU');
  if (!p.cache_statusSend) omit.push('statusS');
  const loaded = portalId === 0 || !!portalMap[portalId];
  const omitSig = omit.slice().sort().join('|');
  const prefKey = 'ifPortalhistory.datagrid.'+portalId+'.'+omitSig;

  return (
    <DatagridConfigurable key={'ph-grid-'+portalId+'-'+(loaded?'1':'0')} preferenceKey={prefKey} bulkActionButtons={false} omit={omit}>
      <TextField source="zeitstempel" />
      <TextField source="avail" />
      <TextField source="preis" />
      <TextField source="zusatzpreis" />
      <TextField source="minlos" />
      <TextField source="maxlos" />
      <TextField source="restrictions" />
      <TextField source="status" />
      <TextField source="statusU" />
      <TextField source="statusS" />
      <TextField source="statusall" />
    </DatagridConfigurable>
  );
};

const ListForm = (props) => (
  <List
    {...props}
    title="Portal History"
    sort={{ field: 'zeitstempel', order: 'DESC' }}
    filters={<ListFilter />}
    pagination={<NoPagination />}
    perPage={1000}
    filterDefaultValues={{ portal: 0, room_category: 0, date: 0, show_all_status: false }}
  >
    <HistoryGrid />
  </List>
);

const Portalhistory = {
  list: ({ classes, ...props }) => (
    <ListForm {...props} classes={classes} />
  ),
};

export default Portalhistory;
